import { TypeCode } from './type-code';

export class ColumnDefinition {
  constructor(
    public name: string,
    public title: string,
    public type: TypeCode,
    public action?: (val: string) => void
  ) {
    this.isDate = type === TypeCode.DateTime;
  }

  isDate: boolean;
  width = 130;
}
